import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BottomNavigation from '../../components/feature/BottomNavigation';

export default function FeedbackPage() {
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState({
    type: 'suggestion',
    subject: '',
    message: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const feedbackTypes = [
    { id: 'suggestion', label: 'Sugestão', icon: 'ri-lightbulb-line', color: 'text-yellow-500' },
    { id: 'bug', label: 'Problema', icon: 'ri-bug-line', color: 'text-red-500' },
    { id: 'compliment', label: 'Elogio', icon: 'ri-heart-line', color: 'text-pink-500' },
    { id: 'other', label: 'Outro', icon: 'ri-chat-3-line', color: 'text-blue-500' }
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simular envio do feedback
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setIsSubmitting(false);
    setIsSubmitted(true);
    
    // Resetar formulário após 3 segundos
    setTimeout(() => {
      setIsSubmitted(false);
      setFeedback({
        type: 'suggestion',
        subject: '',
        message: '',
        email: ''
      });
    }, 3000);
  };

  if (isSubmitted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white rounded-3xl p-8 mx-6 shadow-xl text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4 mx-auto">
            <i className="ri-check-line text-green-500 text-2xl"></i>
          </div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Feedback Enviado!</h2>
          <p className="text-gray-600 mb-6">Obrigado pelo seu feedback. Sua opinião é muito importante para nós!</p>
          <button
            onClick={() => navigate('/settings')}
            className="w-full py-3 bg-emerald-500 text-white rounded-2xl font-medium"
          >
            Voltar às Configurações
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="flex items-center justify-between p-6">
          <button
            onClick={() => navigate('/settings')}
            className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center"
          >
            <i className="ri-arrow-left-line text-gray-600 text-lg"></i>
          </button>
          <h1 className="text-xl font-semibold text-gray-800">Feedback</h1>
          <div className="w-10 h-10"></div>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-6">
        <div className="bg-white rounded-3xl p-6 shadow-sm mb-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-orange-100 rounded-3xl flex items-center justify-center mb-4 mx-auto">
              <i className="ri-message-3-line text-orange-500 text-2xl"></i>
            </div>
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Sua opinião importa!</h2>
            <p className="text-gray-600 text-sm">Compartilhe suas sugestões, reporte problemas ou nos envie elogios.</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Tipo de Feedback */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">Tipo de Feedback</label>
              <div className="grid grid-cols-2 gap-3">
                {feedbackTypes.map((type) => (
                  <button
                    key={type.id}
                    type="button"
                    onClick={() => setFeedback(prev => ({ ...prev, type: type.id }))}
                    className={`p-4 rounded-2xl border-2 transition-all ${
                      feedback.type === type.id
                        ? 'border-emerald-500 bg-emerald-50'
                        : 'border-gray-200 bg-white hover:border-gray-300'
                    }`}
                  >
                    <i className={`${type.icon} ${type.color} text-xl mb-2 block`}></i>
                    <span className="text-sm font-medium text-gray-800">{type.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Assunto */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Assunto</label>
              <input
                type="text"
                value={feedback.subject}
                onChange={(e) => setFeedback(prev => ({ ...prev, subject: e.target.value }))}
                placeholder="Resumo do seu feedback"
                className="w-full p-4 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
                required
              />
            </div>

            {/* Mensagem */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Mensagem</label>
              <textarea
                value={feedback.message}
                onChange={(e) => setFeedback(prev => ({ ...prev, message: e.target.value }))}
                placeholder="Descreva detalhadamente seu feedback..."
                rows={5}
                className="w-full p-4 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent resize-none"
                required
              />
              <p className="text-xs text-gray-500 mt-2 text-right">
                {feedback.message.length}/500
              </p>
            </div>

            {/* Email (opcional) */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email <span className="text-gray-400">(opcional)</span>
              </label>
              <input
                type="email"
                value={feedback.email}
                onChange={(e) => setFeedback(prev => ({ ...prev, email: e.target.value }))}
                placeholder="seu@email.com"
                className="w-full p-4 border border-gray-200 rounded-2xl focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent"
              />
              <p className="text-xs text-gray-500 mt-2">
                Deixe seu email se quiser receber uma resposta
              </p>
            </div>

            {/* Botão de Envio */}
            <button
              type="submit"
              disabled={isSubmitting || !feedback.subject.trim() || !feedback.message.trim()}
              className="w-full py-4 bg-emerald-500 text-white rounded-2xl font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
            >
              {isSubmitting ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                  Enviando...
                </>
              ) : (
                <>
                  <i className="ri-send-plane-line mr-2"></i>
                  Enviar Feedback
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}